import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
export default function GoalTargetActions({
  onViewDetailsClicked,
  children
}) {
  return /*#__PURE__*/_jsx(UITableHoverCell, {
    hoverContent: /*#__PURE__*/_jsx(UIButton, {
      responsive: false,
      size: "extra-small",
      use: "tertiary-light",
      onClick: onViewDetailsClicked,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goals-reporting-lib.table.hoverOptions.progressButton"
      })
    }),
    style: {
      borderLeft: 'none',
      borderRight: 'none'
    },
    children: children
  });
}